import { render, staticRenderFns } from "./HeadTabPopup.vue?vue&type=template&id=74621307&scoped=true&"
import script from "./HeadTabPopup.vue?vue&type=script&lang=js&"
export * from "./HeadTabPopup.vue?vue&type=script&lang=js&"
import style0 from "./HeadTabPopup.vue?vue&type=style&index=0&id=74621307&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74621307",
  null
  
)

export default component.exports